import { render } from "./NavSocial.vue?vue&type=template&id=1637736b&scoped=true"
import script from "./NavSocial.vue?vue&type=script&lang=js"
export * from "./NavSocial.vue?vue&type=script&lang=js"

import "./NavSocial.vue?vue&type=style&index=0&id=1637736b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1637736b"]])

export default __exports__